export enum Dashoard {
  school = 0,
  teachers = 1,
  students = 2,
  parents = 3,
  today = 4,
  upcoming = 5,
  almuni = 6
}
